import { render, staticRenderFns } from "./NsiItemEdit.vue?vue&type=template&id=ac1e42e4&"
import script from "./NsiItemEdit.vue?vue&type=script&lang=js&"
export * from "./NsiItemEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports